import { render, staticRenderFns } from "./ProportionSet.vue?vue&type=template&id=35e86c3c&scoped=true"
import script from "./ProportionSet.vue?vue&type=script&lang=js"
export * from "./ProportionSet.vue?vue&type=script&lang=js"
import style0 from "./ProportionSet.vue?vue&type=style&index=0&id=35e86c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e86c3c",
  null
  
)

export default component.exports